// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kxnvdkqrbiaxefknqjwe.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt4bnZka3FyYmlheGVma25xandlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTY5MTEwNzYsImV4cCI6MjAzMjQ4NzA3Nn0.bY8J-SAUq-a93m3GJQn2o5MXLSm2s37_d1FBluXLTGo';

export const supabase = createClient(supabaseUrl, supabaseKey);
